import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const BookmarkIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M2 1v8.002l2.934-2.936 2.932 2.936V1H2Zm2.934 4.312-2.4 2.4V1.534h4.8v6.18l-2.4-2.4Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const BookmarkIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M2 1v8.002l2.934-2.936 2.932 2.936V1H2Zm2.934 4.312-2.4 2.4V1.534h4.8v6.18l-2.4-2.4Z" />
        </SvgIcon>
    );
};
